import FavoriteIcon from '@mui/icons-material/Favorite';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import { IconButton, Tooltip } from '@mui/material';
import { DataGrid, GridColDef, GridPaginationModel, GridRenderCellParams, GridRowsProp, GridSortModel } from '@mui/x-data-grid'; // Import GridSortModel
import { ReactNode, useEffect, useState, useMemo } from "react";
import { Configure, useInstantSearch, usePagination, useSortBy } from "react-instantsearch";
import { useHistory, useLocation } from "react-router";
import Cookies from "universal-cookie";
import { CommonService } from "../../Service/CommonService";
import { OrderApiService } from "../../Service/OrderApiService";
import SampleOrder from "../popups/SampleOrder";
import CurrencyFormatter from "../Static/CurrencyFormatter";
import '../Dynamic/Typesense.scss';
import ProductCheckoutPopup from '../popups/ProductCheckoutPopup';
import SignupSuccessPopup from '../popups/SignupSuccessPopup';
import EditIcon from '../../assets/images/icons/EditIcon.svg';
import { promises } from 'dns';
import DataGridLoader from '../Common/DataGridLoader';
interface SearchContainerProps {
  children?: ReactNode;
  isShowAssociatedCompanies?: boolean;
  isShowViewMyListingsCompanies?: boolean;
  collectionName?: any;
}

const HitsTableContainer: React.FC<SearchContainerProps> = ({ children, isShowAssociatedCompanies, isShowViewMyListingsCompanies, collectionName }) => {
  const history = useHistory();
  const { status, results } = useInstantSearch();
  const {currentRefinement: currentPage, refine: setPage} = usePagination();
  const userId = new Cookies().get('userId');
  const [wishlistItems, setWishlistItems] = useState<any[]>([]);
  const [soldBarrels, setSoldBarrels] = useState([]);
  const [showHits, setShowHits] = useState(false);
  const [globalFilter, setGlobalFilter] = useState<string>('');
  const location = useLocation();
  const currentPath = location.pathname;
  const companyId = new Cookies().get('companyId');
  const [sortModel, setSortModel] = useState<GridSortModel>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isShowProductCheckoutPopup, setShowProductCheckoutPopup] = useState(false);
  const [isShowAccountUnderReviewPopup, setShowAccountUnderReviewPopup] = useState(false);
  const [paginationModel, setPaginationModel] = useState({
          page: currentPage,
          pageSize: 50,
        });
  const { refine, currentRefinement } = useSortBy({
    items: [
      { label: 'Spirit Type Asc', value: `${collectionName}/sort/ttb_type:asc` },
      { label: 'Spirit Type Desc', value: `${collectionName}/sort/ttb_type:desc` },
      { label: 'Price Asc', value: `${collectionName}/sort/price:asc` },
      { label: 'Price Desc', value: `${collectionName}/sort/price:desc` },
      { label: 'Age Asc', value: `${collectionName}/sort/fill_date_timestamp:asc` },
      { label: 'Age Desc', value: `${collectionName}/sort/fill_date_timestamp:desc` },
      { label: 'Proof Asc', value: `${collectionName}/sort/proof:asc` },
      { label: 'Proof Desc', value: `${collectionName}/sort/proof:desc` },
    ],
  });

  // Sync InstantSearch → DataGrid
  useEffect(() => {
    setPaginationModel(prev => ({
      ...prev,
      page: currentPage - 1,
    }));
  }, [currentRefinement]);

   // Set DataGrid's sortModel to reflect the initial sort
  useEffect(() => {
    if (collectionName) {

        let defaultSortField;
        const defaultSortDirection = 'asc';

        if(collectionName == process.env.REACT_APP_TYPESENSE_WANTED_TO_BUY_COLLECTIONNAME)
          defaultSortField = 'tentative_price';
        else
          defaultSortField = 'price';
        
        setSortModel([{ field: defaultSortField, sort: defaultSortDirection }]);
    }
  }, [collectionName]);

  /*useEffect(() => {
    let filters: string[] | string | undefined = userId;
    if (currentPath === '/user/inventories') {
        filters = userId ? [`company_id:!=${companyId}`] : ['company_id'];
    } else if (currentPath === '/user/my-inventory') {
        filters = userId ? [`company_id:=${companyId}`] : ['company_id'];
    } else if (currentPath === '/user/wish-list') {
        filters = wishlistItems.length > 0 ? [`owner_id:!=${userId}`, `(inventory_id:${wishlistItems.join(' || inventory_id:')})`] : [`owner_id:!=${userId}  &&  inventory_id:null`];
        if(CommonService.isUserLoggedIn()){
          getAllSoldInventoryWishList();
        }
    }

    // Generate dynamic filter string
    const filterValue = Array.isArray(filters) ? filters?.join(' && ').replace(/\\/g, '') : filters;
    setGlobalFilter(filterValue);

  }, [location.pathname, wishlistItems, userId, companyId]);*/

  useEffect(() => {
    let filters: string[] = [];

    if (currentPath === '/user/inventories') {
      if(isShowViewMyListingsCompanies) {
        filters = [`company_id:=${companyId}`];
      }
    }

    if (currentPath === '/user/wanted-to-buy') {
      if (isShowViewMyListingsCompanies) {
        filters.push(`company_id:=${companyId}`);
      }
    }

    if (currentPath === '/user/my-inventory') {
      filters.push(`company_id:=${companyId}`);
    }

    if (currentPath === '/user/wish-list') {
      if (wishlistItems.length > 0) {
        filters.push(`owner_id:!=${userId}`);
        filters.push(`inventory_id:=[${wishlistItems.join(',')}]`);
      } else {
        // Force empty result safely
        filters.push(`inventory_id:=__none__`);
      }
    }

    const filterValue = filters.length > 0 ? filters.join(' && ') : undefined;
    setGlobalFilter(filterValue);

  }, [currentPath, wishlistItems, userId, companyId, isShowViewMyListingsCompanies]);

  const getAllSoldInventoryWishList = async() => {
      try {
          const response = await OrderApiService.getAllSoldInventoryWishList(CommonService.getUserId());
          setSoldBarrels(response.data);
      } catch (error) {
          console.error('Error while fetching barrel availability:', error);
          return false; // Return false in case of an error
      }
  };

  useEffect(() => {
    if(CommonService.isUserLoggedIn()) {
      getUserWishlist();
    }
  }, []);

  const addToWishList = async (itemId: string, productName: string) : Promise<boolean> => {
    const wishListRequest = {
        inventoryId: itemId,
        userId: userId,
        inventoryTitle: productName
    };

    try {
        const response: any = await OrderApiService.addToWishlist(wishListRequest);
        getUserWishlist();
        return true;
    } catch (error) {
        console.error('Error while adding wishlist data:', error);
        if(error?.response?.data?.errorMessage == 'This inventory is no longer available in marketplace') {
            CommonService.Toast.fire({
                title: "This inventory is no longer available in Marketplace",
                icon: "error",
            });
        } 
        return false;
    }
  };

  const getUserWishlist = async () => {
    try {
        const response: any = await OrderApiService.getUserWishlist(userId);

        setWishlistItems(response.data);
    } catch (error) {
        console.error('Error while fetching wishlist:', error);
    }
  };

  const removeFromWishList = async (itemId: string) :Promise<boolean> => {
    const wishListRequest = {
        inventoryId: itemId,
        userId: userId,
    };

    try {
        const response: any = await OrderApiService.removeFromWishlist(wishListRequest);
        getUserWishlist();
        return true;
    } catch (error) {
        console.error('Error while removing wishlist data:', error);
        return false;
    }
  };

  useEffect(() => {

    if(status !== "loading" && status !== "stalled"){
      setIsLoading(false);
      setShowHits(true);
    }else{
      setShowHits(false);
      setIsLoading(true);
    }
  }, [status]);

  const handleSortModelChange = (newSortModel: GridSortModel) => {
    setIsLoading(true)
    setSortModel(newSortModel); 

    if (newSortModel.length > 0) {
      const { field, sort } = newSortModel[0]; 
      const instantSearchSortValue = `${collectionName}/sort/${field}:${sort}`;
      refine(instantSearchSortValue);
    } else {
      refine(`${collectionName}/sort/price:asc`);
    }
  };
  const handleRowClick = (params) => {
    //check if user login or not 
    if(!CommonService.isUserLoggedIn()) {
      CommonService.getSignupStatus() ? setShowAccountUnderReviewPopup(true): setShowProductCheckoutPopup(true);
      return;
    }

    //Row only clickable for users
    if(collectionName == process.env.REACT_APP_TYPESENSE_WANTED_TO_BUY_COLLECTIONNAME){
      if(CommonService.isUser()) {
        history.push(`/user/wanted-to-buy-product-details/${params.row.id}`);
      } else {
        history.push(`/master/wanted-to-buy-product-details/${params.row.id}`);
      }
    }else{
      if(CommonService.isUser()) {
        history.push(`/user/product-details/${params.row.id}`);
      } else {
        history.push(`/master/product-details/${params.row.id}`);
      }
    }
  }

  const handleCancelPopup = () => {
    setShowProductCheckoutPopup(false);
    setShowAccountUnderReviewPopup(false);
  }

  const handleConfirmPopup = () => {
    history.push(`/login`);
  }

  const columns: GridColDef[] = useMemo(() => [
    {
      field: 'ttb_type',
      headerName: 'Spirit Type', 
      flex: 1,
      minWidth:240,
      sortable: true,
      renderCell: (params: GridRenderCellParams) => (
        <div className='d-flex flex-column h-100 justify-content-center list-data-wrapper'>
          <span className='mb-2'>
            <Tooltip title={params.row.ttb_type} arrow>
              <span className='sprint-desc' style={{maxWidth:CommonService.getCompanyId() == params?.row?.company_id  && params?.row?.customer_service_request_id && CommonService.isUser() ? "150px" : "100%"}}>{params.row?.ttb_type || "-"}</span>
              </Tooltip>
             {CommonService.getCompanyId() == params?.row?.company_id  && params?.row?.customer_service_request_id && CommonService.isUser() &&
                <span className='my-listing-tag ms-2'>
                  My Listing
                </span>
                 } 
          </span>
          {params.row.mash_bill?.toUpperCase() !== "UNKNOWN" ? 
            <span className='text-body-tertiary sprint-sub-desc' title={params.row.mash_bill}>
              {params.row?.mash_bill}
            </span>
          : "-"}
        </div>
      ),
    },

    ...(isShowAssociatedCompanies && CommonService.isAdmin() ? [{
      field: 'company_name',
      headerName: 'Company Name',
      flex: 1,
      minWidth:200,
      sortable: false,
      renderCell: (params: GridRenderCellParams) => (
        <div className='d-flex flex-column h-100 justify-content-center list-data-wrapper'>
          <Tooltip title={params.row.company_name} arrow>
          <span className='company-name'>{params.row.company_name}</span>
          </Tooltip>
        </div>
      ),
    }] : isShowViewMyListingsCompanies && CommonService.isUser() ? [{
          field: 'company_name',
          headerName: 'Company Name',
          flex: 1,
          minWidth: 200,
          sortable: false,
          renderCell: (params: GridRenderCellParams) => (
            <div className="d-flex flex-column h-100 justify-content-center list-data-wrapper">
              <Tooltip title={params.row.company_name} arrow>
                <span className="company-name">
                  {params.row.company_name}
                </span>
              </Tooltip>
            </div>
          ),
        }]
      : []),
    {
      field: 'price',
      headerName: 'Price $',
      flex: 1,
        minWidth:130,
      sortable: true,
      renderCell: (params: GridRenderCellParams) => (
        <div className='d-flex flex-column h-100 justify-content-center list-data-wrapper'>
          <CurrencyFormatter amount={params.row.price} locale="en-US" currency="USD" />
          <span className='text-body-tertiary sprint-sub-desc'>Per Container</span>
        </div>
      ),
    },
    {
      field: 'fill_date_timestamp',
      headerName: 'Age',
      flex: 1,
      minWidth:150,
      sortable: true,
      renderCell: (params: GridRenderCellParams) => {
        const { years, months } = CommonService.calculateAge(params.row.fill_date_timestamp);
        return (
          <div className='d-flex flex-column h-100 justify-content-center list-data-wrapper'>
            <span>{years} years {months} months</span>
          </div>
        );
      },
    },
    {
      field: 'proof',
      headerName: 'Proof',
      flex: 1,
      minWidth:80,
      sortable: true,
      renderCell: (params: GridRenderCellParams) => (
        params.row.proof != '0' ? (
          <div className='d-flex flex-column h-100 justify-content-center list-data-wrapper'>
            <span>{CommonService.formatToSingleDecimal(params.row.proof)}</span>
            <span className='text-body-tertiary sprint-sub-desc'>
              {params.row.proof_unit?.toLowerCase().split(' ').map((word: string) => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}
            </span>
          </div>
        ) : "-"
      ),
    },
    ...(currentPath === '/user/inventories' || currentPath === '/master/inventories' || currentPath === '/user/wish-list' ? [{
      field: 'actions',
      headerName: 'Action',
      flex: 1,
      minWidth:130,
      sortable: false,
      renderCell: (params: GridRenderCellParams) => (
        <HitItem
          hit={params.row}
          addToWishList={addToWishList}
          removeFromWishList={removeFromWishList}
          wishlistItems={wishlistItems}
          currentPath={currentPath}
          onTriggerCheckoutPopup={() => setShowProductCheckoutPopup(true)}
          onTriggerUnderReviewPopup={() => setShowAccountUnderReviewPopup(true)}
          isShowAssociatedCompanies ={isShowAssociatedCompanies}
          isShowViewMyListingsCompanies={isShowViewMyListingsCompanies}
        />
      ),
    }] : []),
  ], [currentPath, addToWishList, removeFromWishList, wishlistItems]);

  const wantedToBuycolumns: GridColDef[] = useMemo(() => [
    {
      field: 'product_name',
      headerName: 'Product Name', 
      flex: 1,
      minWidth:240,
      sortable: true,
      renderCell: (params: GridRenderCellParams) => (
        <div className='d-flex flex-column h-100 justify-content-center list-data-wrapper'>
          <span className='mb-2'>
            <Tooltip title={params.row.product_name} arrow>
              <span className='sprint-desc' style={{maxWidth:CommonService.getCompanyId() == params?.row?.company_id && params?.row?.customer_service_request_id && CommonService.isUser() ? "150px" : "100%"}}>{params.row.product_name}</span>
            </Tooltip>
            {CommonService.getCompanyId() == params?.row?.company_id && params?.row?.customer_service_request_id && CommonService.isUser() &&
                <span className='my-listing-tag ms-2'>
                  My Listing
                </span>}
          </span>
          <span className='text-body-tertiary sprint-sub-desc' title={params.row.mash_bill}>
            {params.row.mash_bill}
          </span>
        </div>
      ),
    },

    ...(isShowAssociatedCompanies && CommonService.isAdmin() ? [{
      field: 'company_name',
      headerName: 'Company Name',
      flex: 1,
      minWidth:200,
      sortable: false,
      renderCell: (params: GridRenderCellParams) => (
        <div className='d-flex flex-column h-100 justify-content-center list-data-wrapper'>
          <Tooltip title={params.row.company_name} arrow>
          <span className='company-name'>{params.row.company_name}</span>
          </Tooltip>
        </div>
      ),
    }] : isShowViewMyListingsCompanies && CommonService.isUser() ? [{
      field: 'company_name',
      headerName: 'Company Name',
      flex: 1,
      minWidth:200,
      sortable: false,
      renderCell: (params: GridRenderCellParams) => (
        <div className='d-flex flex-column h-100 justify-content-center list-data-wrapper'>
          <Tooltip title={params.row.company_name} arrow>
          <span className='company-name'>{params.row.company_name}</span>
          </Tooltip>
        </div>
      ),
    }] : []),

    {
      field: 'tentative_price',
      headerName: 'Price $',
      flex: 1,
        minWidth:130,
      sortable: true,
      renderCell: (params: GridRenderCellParams) => (
        <div className='d-flex flex-column h-100 justify-content-center list-data-wrapper'>
          <CurrencyFormatter amount={params.row.tentative_price} locale="en-US" currency="USD" />
          <span className='text-body-tertiary sprint-sub-desc'>Per Container</span>
        </div>
      ),
    },
    {
      field: 'age_from',
      headerName: 'Age',
      flex: 1,
      minWidth:150,
      sortable: true,
      renderCell: (params: GridRenderCellParams) => {
        return (
          <div className='d-flex flex-column h-100 justify-content-center list-data-wrapper'>
            <span>{params.row.age_from} years {params.row.age_to} years</span>
          </div>
        );
      },
    },
    {
      field: 'proofing_min',
      headerName: 'Proof',
      flex: 1,
      minWidth:80,
      sortable: true,
      renderCell: (params: GridRenderCellParams) => (
        <div className='d-flex flex-column h-100 justify-content-center list-data-wrapper'>
          <span>{CommonService.formatToSingleDecimal(params.row.proofing_min)} - {CommonService.formatToSingleDecimal(params.row.proofing_max)}</span>
           <span className='text-body-tertiary sprint-sub-desc'>
            {params.row.proof_unit?.toLowerCase().split(' ').map((word: string) => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}
          </span>
        </div>
      ),
    },
    ...(currentPath === '/user/wanted-to-buy' || currentPath === '/master/wanted-to-buy' ? [{
      field: 'actions',
      headerName: 'Action',
      flex: 1,
      minWidth:130,
      sortable: false,
      renderCell: (params: GridRenderCellParams) => (
        <HitItem
          hit={params.row}
          addToWishList={addToWishList}
          removeFromWishList={removeFromWishList}
          wishlistItems={wishlistItems}
          currentPath={currentPath}
          onTriggerCheckoutPopup={() => setShowProductCheckoutPopup(true)}
          onTriggerUnderReviewPopup={() => setShowAccountUnderReviewPopup(true)}
          isShowAssociatedCompanies ={isShowAssociatedCompanies}
          isShowViewMyListingsCompanies ={isShowViewMyListingsCompanies}
        />
      ),
    }] : []),
  ], [currentPath, addToWishList, removeFromWishList, wishlistItems]);

  const rows: GridRowsProp = results?.hits?.map((hit: any) => ({
    id: hit.id,
    ...hit,
  })) || [];

  // Sync DataGrid → InstantSearch
  const handlePaginationChange = (model: GridPaginationModel) => {
    setPaginationModel(model);
    setPage(model.page); // MUI is 0-based, InstantSearch is 1-based
  };

  return (
    <>
    <div className="table-container mt-3" style={{ width: '100%' }}>
      <Configure hitsPerPage={paginationModel.pageSize} filters={globalFilter}/>
      <DataGrid
        rows={rows}
        columns={collectionName == process.env.REACT_APP_TYPESENSE_WANTED_TO_BUY_COLLECTIONNAME ? wantedToBuycolumns : columns}
        pageSizeOptions={[10, 20, 50, 100]}
        pagination
        paginationMode="server"
        paginationModel={paginationModel}
        onPaginationModelChange={handlePaginationChange}
        rowCount={results?.nbHits || 0}
        loading={isLoading}
        slots={{
          loadingOverlay: DataGridLoader,
        }}
        rowHeight={60}
        className='data-grid marketplace-list-table'
        sortingMode="server" // sorting is handled by the InstantSearch
        sortModel={sortModel}
        onSortModelChange={handleSortModelChange}
        onRowClick={handleRowClick}
        disableColumnResize
        disableColumnMenu 
        sx={{
            '& .MuiDataGrid-columnHeaders': {
                backgroundColor: 'rgba(224, 224, 224, 1)',
            },
            '& .MuiDataGrid-row': {
                cursor: 'pointer',
            },
            '.MuiDataGrid-cell': {
                borderBottom: '1px solid #f5f5f5',
            },
        }}
      />
    </div>
       {isShowProductCheckoutPopup && (
        <ProductCheckoutPopup
          onCancel={handleCancelPopup}
          onConfirm={handleConfirmPopup}
        />
      )}

      {isShowAccountUnderReviewPopup && (
          <SignupSuccessPopup
            onBrowseMarketPlace={handleCancelPopup}
            onCancel={handleCancelPopup}
            type= "PENDING_REVIEW"
          />
      )}
    </>
  );
  
};
   
interface HitItemProps {
  hit: any;
  addToWishList: (itemId: string, productName: string) => Promise<boolean>;
  removeFromWishList: (itemId: string) => Promise<boolean>;
  wishlistItems: any[];
  currentPath: string;
  onTriggerCheckoutPopup: () => void;
  onTriggerUnderReviewPopup: () => void;
  isShowAssociatedCompanies: boolean;
  isShowViewMyListingsCompanies: boolean
}

const HitItem: React.FC<HitItemProps> = ({
  hit,
  addToWishList,
  removeFromWishList,
  wishlistItems,
  currentPath,
  onTriggerCheckoutPopup,
  onTriggerUnderReviewPopup,
  isShowAssociatedCompanies,
  isShowViewMyListingsCompanies,
}) => {  
   
   const [isInWishlist, setIsInWishlist] = useState(false);
   const history = useHistory();

    useEffect(() => {
        if (isInWishlist !== wishlistItems.includes(hit.inventory_id)) {
            setIsInWishlist(wishlistItems.includes(hit.inventory_id));
        }
    }, [wishlistItems, hit.inventory_id]);

    const manageWishList = async (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
      event.stopPropagation();

      // Restrict access to Super Admins and users belonging to the same company as the inventory
      if(CommonService.isAdmin() || CommonService.isSameCompany(hit?.company_id)) {
        return ;
      }

      //if user is not loggedIn then show the checkout popup for login
      if (!CommonService.isUserLoggedIn()) {
        CommonService.getSignupStatus() ? onTriggerUnderReviewPopup() : onTriggerCheckoutPopup();
        return;
      }

      if (isInWishlist) {
        const success = await removeFromWishList(hit.inventory_id);
        if (success) {
          setIsInWishlist(false);
        }
      } else {
        const success = await addToWishList(hit.inventory_id, hit.productName);
        if (success) {
          setIsInWishlist(true);
        }
      }
    };

    const stopPropagation = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        event.stopPropagation();
    };

    const handleEditSellRequest = (customerServiceRequestId:any) => {
      history.push(`${CommonService.isUser() ? '/user' : '/master'}` + `/edit-customer-service-request/${customerServiceRequestId}`);
    }

    const handleEditWantedToBuyRequest = (customerServiceRequestId:any) => {
      history.push(`${CommonService.isUser() ? '/user' : '/master'}` + `/edit-customer-service-request/${customerServiceRequestId}`);
    }

    return (
      <>
        <div className="d-flex align-items-center" onClick={stopPropagation}>
            {(currentPath === '/user/inventories' || currentPath === '/master/inventories' || currentPath === '/user/wish-list') && (
                <>
                    <div className='manageWishList me-2' onClick={manageWishList}>
                        {isInWishlist ? (
                            <Tooltip title={CommonService.isAdmin() ? 'This feature is not available for Super Admins.': (CommonService.isSameCompany(hit?.company_id) ? 'This Action is disabled due to My Listing' :'Remove from Wishlist')} arrow>
                                <FavoriteIcon sx={{ cursor: 'pointer', color: 'red' }} />
                            </Tooltip>
                        ) : (
                            <Tooltip title={CommonService.isAdmin() ? 'This feature is not available for Super Admins.': (CommonService.isSameCompany(hit?.company_id) ? 'This Action is disabled due to My Listing' :'Add to Wishlist')} arrow>
                                <FavoriteBorderIcon sx={{ cursor: 'pointer', color: '#D9D9D9' }} />
                            </Tooltip>
                        )}
                    </div>
                   {CommonService.isUserLoggedIn() && (<div className="request__sample ms-1" onClick={stopPropagation}>
                        <SampleOrder
                            id={hit.id}
                            inventoryName={hit.product_name}
                            companyId = {hit.company_id}
                            text={false}
                        />
                    </div>)}
                    {((CommonService.getCompanyId() == hit.company_id) || (CommonService.isAdmin() && isShowAssociatedCompanies)) && hit?.customer_service_request_id && <Tooltip title="Edit" arrow>
                      <IconButton
                        aria-label="edit"
                        size="small"
                        className='ms-2 me-2'
                        onClick={() => handleEditSellRequest(hit?.customer_service_request_id)}
                      >
                        <img
                          src={EditIcon}
                          className="cursor-pointer"
                          alt="EditIcon"
                        />
                      </IconButton>
                    </Tooltip>}
                </>
            )}
            {(currentPath === '/user/wanted-to-buy' || currentPath === '/master/wanted-to-buy') && (
                <>
                    {((CommonService.getCompanyId() == hit.company_id) || (CommonService.isAdmin() && isShowAssociatedCompanies)) && hit?.customer_service_request_id && <Tooltip title="Edit" arrow>
                      <IconButton
                        aria-label="edit"
                        size="small"
                        className='ms-2 me-2'
                        onClick={() => handleEditWantedToBuyRequest(hit?.customer_service_request_id)}
                      >
                        <img
                          src={EditIcon}
                          className="cursor-pointer"
                          alt="EditIcon"
                        />
                      </IconButton>
                    </Tooltip>}
                </>
            )}
        </div>
      </>
    );
};

export default HitsTableContainer;
